import {computed} from 'mobx';
import {MatchEventsModuleRowViewModel} from "./match-events-module.row-view-model";
import {StageViewModel} from "../../../../../domain/full-game/models/stage/stage-view-model";
import {GAME_STAGES_ID} from "../../../../../core/app/consts";

export class MatchEventsModuleStageViewModel extends StageViewModel {
  eventRows: Array<MatchEventsModuleRowViewModel> = [];

  constructor(model: MatchEventsModuleStageViewModel, scoreText: String, eventRows: Array<MatchEventsModuleRowViewModel> = []) {
    super(model, scoreText);

    this.eventRows.push(...eventRows);
  }

  @computed get hasNoEvents(): Boolean {
    const hasNoEvents: Boolean = !this.eventRows.length && !this.isCurrent;

    return hasNoEvents;
  }

  get isPenalties() {
    const isPenalties = this.id === GAME_STAGES_ID.penalties;

    return isPenalties;
  }
}
